import React, { createContext, useState } from "react";
import { toast } from "react-toastify";
import LOCAL_KEYS, { parseLocalStorageJSON, setToLocalStorage } from "../../helpers/localstorage";
import Swal from "sweetalert2";
import { login as loginApi, forgotPassword as forgotPasswordApi} from "../../Services/authapis";

export const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [loginResponse, setLoginResponse] = useState(null);
  const [loginError, setLoginError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getProfilePhoto = () => {
    const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
    
    // Get the first character of first and last name to determine an image number (for consistent results)
    const firstInitial = userDetails?.firstName?.charAt(0)?.toLowerCase() || 'a';
    const lastInitial = userDetails?.lastName?.charAt(0)?.toLowerCase() || 'b';
    const charCode1 = firstInitial.charCodeAt(0) || 97; // 'a' is 97
    const charCode2 = lastInitial.charCodeAt(0) || 98;  // 'b' is 98
    
    // Generate a gender and image number based on the user's name (for consistent results)
    const gender = (charCode1 % 2 === 0) ? 'men' : 'women';
    const imageNumber = ((charCode1 + charCode2) % 70) || 1; // RandomUser has ~70 images per category
    
    return {
      src: `https://randomuser.me/api/portraits/${gender}/${imageNumber}.jpg`,
      fallback: `https://ui-avatars.com/api/?name=${userDetails?.firstName || ''}+${userDetails?.lastName || ''}&background=2563EB&color=FFFFFF`
    };
  };


  const login = async (credentials) => {
    setIsLoading(true);
    try {
      // Simulate API call
      const response = await loginApi(credentials);
      setLoginResponse(response);

      // Allow ADMIN, MKTG_EXEC (marketing executive), and RECRUITER users
      if (response?.userDetails?.acctType !== "ADMIN" && response?.userDetails?.acctType !== "MKTG_EXEC" && response?.userDetails?.acctType !== "RECRUITER") {
        Swal.fire({
          title: "Error",
          text: "Invalid User",
          icon: "error",
          confirmButtonText: "Ok",
        });
        resetLoginState();
      } else if (response.access_token) {
        localStorage.setItem("access_token", response.access_token);
        setToLocalStorage(LOCAL_KEYS.USER_DETAILS, response.userDetails);

        if (response.message) {
          setToLocalStorage(LOCAL_KEYS.EXPIRY, true);
          toast.error("Your password is expired, please reset your password");
          resetLoginState();
        } else {
          toast.success("Login successful");
        }
      }
    } catch (error) {
      setLoginError(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  // Forgot Password function
  const forgotPassword = async (email) => {
    setIsLoading(true);
    try {
      // Call your API (should be a POST or GET as per your backend)
      const response = await forgotPasswordApi(email);
      toast.success("Password reset email sent!");
      return response;
    } catch (error) {
      toast.error(error.message || "Failed to send reset email");
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetLoginState = () => {
    setLoginResponse(null);
    setLoginError(null);
  };

  return (
    <LoginContext.Provider
      value={{ loginResponse, loginError, isLoading, login, resetLoginState, forgotPassword, getProfilePhoto }}
    >
      {children}
    </LoginContext.Provider>
  );
};

// Simulated API call (replace with actual API logic)
